import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'

export default class Home extends Component {
  render() {
    return (
      <Query
        query={
          gql`
            query {
              me {
                id
                employee {
                  id
                  status
                }
              }
            }
          `
        }>
        {({ loading, error, data }) => {
          if (loading || error) {
            return null
          }

          let isPicsaEmployee = data.me.employee !== null && data.me.employee.status === 'ACTIVE'
          localStorage.setItem('isUserPicsaEmployee', isPicsaEmployee)
          // TODO: replace 'isUserPicsaEmployee' with something more secure; if in
          //    anyway a malicious person will add 'isUserPicsaEmployee' key to
          //    localStorage and set to true, they'll gain access; replace with util function maybe

          if (isPicsaEmployee) {
            return <Redirect push to='/os/cases' />
          } else {
            return <Redirect push to={`${this.props.match.url}/dashboard`} />
          }
        }}

      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Home.js